import { saveAs } from 'file-saver';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import { downloadECSLExcel } from '@api/ecsl';
import types from '@constants/action-types';
import { toastError } from '@store/notifications';

export const handleGetECSLDownload = function* ({ payload }) {
  try {
    yield call(payload.setLoading, true);

    const response = yield call(downloadECSLExcel, payload.id);

    const file = new Blob([response?.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      encoding: 'UTF-8',
    });

    yield call(saveAs, file, 'standard_ecsl_ecpl_list');
  } catch (e) {
    yield put(
      toastError({
        message: {
          id: 'global.notification.api-error-default',
          defaultMessage: 'An error occurred. Please try again.',
        },
      })
    );
  } finally {
    yield call(payload.setLoading, false);
  }
};

export default all([takeEvery(types.GET_ECSL_DOWNLOAD_START, handleGetECSLDownload)]);
